<template>
  <div id="popup-box-gfcr-1" :style="isShowable" class="popupally-overlay-gfcr-1 popup-click-close-trigger-1">
   <div class="popupally-outer-gfcr-1">
    <div class="popupally-inner-gfcr-1">
     <div class="popupally-center-gfcr">
      <div class="desc-gfcr">
       <!-- SUBSCRIBE TO OUR NEWSLETTER &amp; RECEIVE A COUPON FOR -->
       {{item.title}}
      </div>
      <div class="logo-row-gfcr">
       <div class="clear-gfcr"></div>
       <img class="logo-img-gfcr" :src="[$consts.serverPath + item.icon]" alt="" />
       <div class="logo-text-gfcr">
        ---{{item.discount_rate}}% OFF---
       </div>
       <div class="clear-gfcr"></div>
      </div>
      <form action="https://www.aweber.com/scripts/addlead.pl" popupally-popup="1" class="popupally-signup-form-ishdye content-gfcr" method="post" v-on:submit.prevent="onSubmit">
      <!--  <input type="hidden" name="meta_web_form_id" value="671663073" />
      <input type="hidden" name="meta_split_id" value="" />
      <input type="hidden" name="listname" value="awlist4683416" />
      <input type="hidden" name="redirect" value="https://www.aweber.com/thankyou-coi.htm?m=text" />
      <input type="hidden" name="meta_adtracking" value="KPKitchen_Newsletter" />
      <input type="hidden" name="meta_message" value="1" />
      <input type="hidden" name="meta_required" value="name,email" />
      <input type="hidden" name="meta_tooltip" value="" />
      <input type="hidden" name="submit" value="" /> -->
       <input type="text" name="name" class="field-gfcr" required v-model.trim="name"  placeholder="Enter Your First Name Here" />
       <input type="email" name="email" required class="field-gfcr" v-model.trim="email" placeholder="Enter Your Email Here" />
       <input type="submit" class="popupally-form-submit submit-gfcr" :value="['Get My ' + item.discount_rate + ' % Off']" />
      </form>
      <div class="privacy-gfcr">
       *Coupon only valid for first-time registrants. Coupon cannot be combined with any other offer. Entering your email address makes you eligible to receive future promotional emails.
      </div>
     </div>
    </div>
    <div title="Close" @click="close()" class="popupally-close-gfcr popup-click-close-trigger-1"></div>
   </div>
  </div>
</template>
<script>
import api from '../api.js'
export default {
    data() {
        return {
            item:{title:"", discount_rate:0},
            isShowable:"",
            name:"",
            email:"",
        }
    },
    async mounted() {
        const res = await api.get('/api/popup/0');
        if (res.data.code == 1) {
            this.item = res.data.message.item;
            setTimeout(function(){
                this.isShowable = 'display:block';
            }.bind(this), this.item.seconds_to_load*1000);
        }
    },
    methods:{
        close: function() {
            this.isShowable = "";
        },
        onSubmit:async function() {
            const res = await api.post('/api/subscribe', {name: this.name, email:this.email});
            let message = {
              title: 'Subscribe to receive future promotions',
              body:'',
            };
            if (res.data.code == 1) {
                message.body = '<span style="color:green">Success, Thanks for your subscription!<span>';
                this.$dialog.alert(message).then(function(){
                  this.isShowable = "";
                }.bind(this));
            } else {
              message.body = '<span style="color:red">' + res.data.message + '<span>';
              this.$dialog.alert(message);
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Subscribe.vue